module.exports = function (bootstrap) {
    bootstrap.directive('siteFooter', ["$rootScope", "$state",  "$filter", "$window", "link", "brand", "navigation", "services","sessionData", "teamsite","taglines","session", "appId","$cookies",
        function ($rootScope, $state, $filter, $window, link, brand, navigation, services,sessionData, teamsite,taglines, session, appId, $cookies) {
        return {
            replace: true,
            scope: {
                showLanguages: '=',
                cmsCode: '=?',
                hideBuildDate: '=?',
                hideDisclosures: '=?'
            },
            controller: ["$scope", function ($scope) {
                var REGIONAL_LANGUAGES_CONTENT_ID = 'REGIONAL_LANGUAGES',
                    MBR_MEANINGFUL_ACCESS_LINK_ID = 'MBR_MEANINGFUL_ACCESS_LINK',
                    MBR_MEANINGFUL_ACCESS_LINK_BTS3_NDMEDICAID_ID = 'MBR_MEANINGFUL_ACCESS_LINK_BTS3_NDMEDICAID',
                    APPROVAL_FOOTER_MESSAGE_BEGIN = "CMS_",
                    APPROVAL_FOOTER_MESSAGE_END = "_FOOTER_MESSAGE";

                //var needHelpCoremetricsFlag = false;
                $scope.shouldShowLanguagesFooter = false;
                $scope.isFetchingLanguages = false;

                var hideMentalHealth = ['wybcbs','ndbcbs','idh','mincr','ibcr','ibcah','fl','mn','az', 'neb', 'pp', 'la'];
                if (hideMentalHealth.indexOf(brand.current.sharedBrandCode) > -1){
                    $scope.isPlanPartner = true;
                }

                $scope.isSenior = appId.toLowerCase() === 'medweb';
                $scope.isNDBCBS = brand.current.ubk=== 6011;
                $scope.ndLanguageAssistance = "https://www.bcbsnd.com/documents/10181/6527267/Language_and_Disability_Access_Assistance/f6538f54-3702-4ac6-9d46-9a8b8f981df3";
                $scope.isWYBCBS = brand.current.ubk=== 6012;
                $scope.translationServices = "https://www.bcbswy.com/docs/Translation_NonDiscrimination.pdf";
                $scope.nonDiscriminationNotices = "https://www.bcbswy.com/docs/Translation_NonDiscrimination.pdf#page=2";
                
                $scope.footerMoreInfo = {};
                $scope.isMINCR = (brand.current.sharedBrandCode === 'mincr') ? true : false;
                $scope.isUB = (brand.current.sharedBrandCode === 'UB' ||  ($cookies.get('umsBrand') && $cookies.get('umsBrand') === 'UB')) ? true : false;
                // services.rbsmbl.memberInfo().fetch().then(function (userData) {
                //     // $scope.isUB = (brand.current.sharedBrandCode.toUpperCase() === 'UB') ? true : false;
                //     $scope.isUB = (userData.data.payload.brand.toUpperCase() === 'UB') ? true : false;
                // });
                teamsite.get('MBR_FOOTER_CMS').then(function (res) {
                             var cmsFooterLink = JSON.parse(res);
                             $scope.cmsInteroperability = cmsFooterLink;
                             },function(error) {
                             $scope.cmsInteroperability = false;
                             });
                $scope.brandValue = brand.current.sharedBrandCode;
                $scope.cmsCode = $scope.cmsCode || function (stateName) {
                        $scope.footerMoreInfo = {"cmsCode": false};
                        if (stateName !== "") {
                            // FIXME: This code needs re-visited, but fixing prod issue for now because brand needs to be upper case for content info service...
                            teamsite.setQualifier('brand', (brand.current.umsBrandCode || brand.current.sharedBrandCode).toUpperCase());
                            teamsite.get(APPROVAL_FOOTER_MESSAGE_BEGIN + stateName.toUpperCase() + APPROVAL_FOOTER_MESSAGE_END).then(function (response) {
                                $scope.footerMoreInfo = {"cmsCode": response};
                            });
                        }
                        if(window.location.href.search(/medicare=yes/i) !== -1 || sessionData.isMedicare) {
                            $scope.footerMoreInfo.cmsCode = "Y0037_19_4505_M";
                        }
                    };
                

                //Footer Approval Logic

                if (typeof $scope.cmsCode === 'function') {
                    $scope.$watch(function () {
                            return $state.current.name;
                        }, function (stateName, previousStateName) {
                            if (stateName !== previousStateName && typeof $scope.cmsCode === 'function') {
                                $scope.cmsCode(stateName, $scope);
                            }
                        }
                    );
                }


                // Set up scope variables for languages and meaningful-access link.
                $scope.languages = [];
                $scope.meaningfulAccessURL = null;

                var populateFooterLanguagesMenu = function () {
                    if ($scope.isFetchingLanguages) {
                        return;
                    }
                    $scope.isFetchingLanguages = true;
                    // Get Languages content from the taglines factory.
                    $scope.languages = [];

                    var allLanguages = {};
                    taglines.getAllLanguages().then(
                        function (result) {
                            allLanguages = result;
                        }, function (error) {
                        }
                    ).finally(function () {
                        // Set up $scope.languages based off of teamsite.
                        teamsite.get(REGIONAL_LANGUAGES_CONTENT_ID).then(
                            function (response) {
                                var regionalLanguages = JSON.parse(response);
                                // For each langugage code in the languages property, ...
                                angular.forEach(regionalLanguages.languages, function (item) {
                                    // ...if the language code is in allLanguages, ...
                                    if (allLanguages[item]) {
                                        // ...push the language information from allLanguages into $scope.languages.
                                        $scope.languages.push(allLanguages[item]);
                                    }
                                });

                                $scope.isFetchingLanguages = false;
                            }, function (error) {
                                $scope.isFetchingLanguages = false;
                            }
                        );
                    });
                    if($scope.session.loggedIn){
                        var isNdMedicaid= services.rbsmbl.memberInfo().getPortalSelectedPlan().isNDMedicaid;
                        $scope.nonDiscriminationND = false;
                        if(isNdMedicaid && $scope.isNDBCBS){
                            $scope.nonDiscriminationND =true;
                        }
    
                        var teamsiteLinkId = $scope.nonDiscriminationND ? MBR_MEANINGFUL_ACCESS_LINK_BTS3_NDMEDICAID_ID : MBR_MEANINGFUL_ACCESS_LINK_ID;
                        // Get the URL for the meaningful-access page from teamsite.
                        teamsite.get(teamsiteLinkId).then(
                            function (response) {
                                var languageLink = JSON.parse(response);
                                $scope.meaningfulAccessURL = languageLink.href;
                            }, function (error) {
                            }
                        );
                    }
                    

                };

                $scope.session = sessionData;
                $scope.footerLinkClick = function (link, $event) {
                    if ($window.innerWidth < 936) {
                        link.hideSub = !link.hideSub;
                        $event.stopPropagation();
                    }
                };

                $scope.isExpanded = function (link) {
                    var isHidden = link.hideSub || false;
                    return $window.innerWidth < 936 ? isHidden : true;
                };

                var footerResize = function () {
                    var footerLinksLength = 0;
                    for (var i in $scope.navigation.footerLinks) {
                        if (!$scope.navigation.footerLinks[i].hide) {
                            footerLinksLength++;
                        }
                    }
                    var ww = $window.innerWidth || $($window).width();
                    if (ww > 1243) {
                        var perColumn = Math.ceil(footerLinksLength / 4);
                        var remainder = footerLinksLength % 4;
                    }
                    else {
                        var perColumn = Math.ceil(footerLinksLength / 3);
                        var remainder = footerLinksLength % 3;
                    }

                    var column = 1;
                    var x = 1;
                    var reduced = false;
                    // var orderedLinks = $filter('orderByLink')($scope.navigation.footerLinks, 'order');
                    var orderedLinks = $scope.navigation.footerLinks || [];
                    var threeInFirstColumn = orderedLinks.filter(function(link) {return link.id == "memberPrePasswordPayPremium";}).length > 0;

                    // Angular cannot automatically sort objects in ngRepeat, so we use a custom filter.
                    // Since this filter is applied in the ngRepeat in html, we need to apply it here as well before we
                    // assign columns to each link.  If not, the links would be assigned columns in the order they appear
                    // in code, ignoring their order field.
                    for (var z = 0; z < orderedLinks.length; z++) {
                        if (!orderedLinks[z].hide) {
                            orderedLinks[z].column = column;
                            if (threeInFirstColumn) orderedLinks[2].column = 1;
                            if (x++ >= perColumn) {
                                column++;
                                x = 1;
                            }
                            if (remainder && !reduced && column > remainder) {
                                perColumn--;
                                reduced = true;
                            }
                        }
                    }
                };
                $scope.session = session.data;
                $scope.brandData = brand.current;
                $scope.navigation = navigation.data;
                $scope.buildDate = new Date($window.buildInfo.buildDate);
                $scope.$watch("navigation.footerLinks", function (a) {
                    if(typeof($scope.navigation.footerLinks) !== "undefined") {
                        if (window.location.href.indexOf('find-a-doctor') > -1 && !$scope.session.loggedIn && $scope.isWYBCBS) {
                            for (i = 0; i < $scope.navigation.footerLinks.length; i++) {
                                if ($scope.navigation.footerLinks[i].links.length > 0) {
                                    for (j = 0; j < $scope.navigation.footerLinks[i].links.length; j++) {
                                        if ($scope.navigation.footerLinks[i].links[j].label.indexOf("Privacy & Legal") > -1) {
                                            $scope.navigation.footerLinks[i].links.splice(j, 1);

                                        }
                                    }
                                }
                            }
                        }
                        if($scope.session.appConfig && $scope.session.appConfig.SPLASH && $scope.session.appConfig.SPLASH.NO_SURPRISES_ACT){

                            for (i = 0; i < $scope.navigation.footerLinks.length; i++) {
                                if ($scope.navigation.footerLinks[i] &&
                                    $scope.navigation.footerLinks[i].label.indexOf("No Surprises Act") > -1
                                    && !$scope.session.appConfig.SPLASH.NO_SURPRISES_ACT.booleanValue) {
                                            $scope.navigation.footerLinks.splice(i, 1);
                                }
                                if ($scope.navigation.footerLinks[i] && $scope.navigation.footerLinks[i].links.length > 0) {
                                    for (j = 0; j < $scope.navigation.footerLinks[i].links.length; j++) {
                                        if ($scope.navigation.footerLinks[i].links[j].label.indexOf("No Surprises Act") > -1
                                        && !$scope.session.appConfig.SPLASH.NO_SURPRISES_ACT.booleanValue) {
                                            $scope.navigation.footerLinks[i].links.splice(j, 1);

                                        }
                                    }
                                }
                            }
                        }
                    }
                    footerResize();
                });
                $scope.$watch("session.loggedIn", function () {
                    $scope.shouldShowLanguagesFooter = taglines.shouldShowLanguages($scope.session.appConfig, $scope.showLanguages);
                    if ($scope.shouldShowLanguagesFooter) {
                        populateFooterLanguagesMenu();
                    }

                });
                if(window.location.href.search(/medicare=yes/i) !== -1 || sessionData.isMedicare) {
                    console.log("please update footer");
                    // set medicare specific links
                    sessionData.isMedicare = true;
                    var memberPrePasswordLearnLink = link.set('memberPrePasswordLearn', {
                        "label": "Learn",
                        "url": false,
                        "mSite": false,
                        "filterData": {
                            "brand": ['*'],
                            "portal": "member"
                        },
                        "links": [
                            link.set("memberPrePasswordLearn1", {
                                "url":"https://medicare.highmark.com/learn/choosing-a-plan",
                                "label":"Shop",
                                "filterData": {
                                    "brand": ['*']
                                }
                            }),
                            link.set("memberPrePasswordLearn2", {
                                "url":"https://medicare.highmark.com/learn/enrollment-timeline",
                                "label":"Enroll",
                                "filterData": {
                                    "brand": ['*']
                                }
                            }),
                            link.set("memberPrePasswordLearn3", {
                                "url":"https://medicare.highmark.com/learn/extra-benefits-and-services",
                                "label":"Extra Benefits and Services",
                                "filterData": {
                                    "brand": ['*']
                                }
                            })
                        ]
                    });
                    var memberPrePasswordCompareShopLink = link.set('memberPrePasswordCompareShop', {
                        "label": "Compare & Shop",
                        "url": false,
                        "mSite": false,
                        "filterData": {
                            "brand": ['*'],
                            "portal": "member"
                        },
                        "links": [
                            link.set("memberPrePasswordCompareShop1", {
                                "url":"https://medicare.highmark.com/compare-shop",
                                "label":"View Plans & Details",
                                "filterData": {
                                    "brand": ['*']
                                }
                            }),
                            link.set("memberPrePasswordCompareShop2", {
                                "url":"https://medicare.highmark.com/compare-shop/about-you",
                                "label":"Estimate Prescription Drug & Medical Costs",
                                "filterData": {
                                    "brand": ['*']
                                }
                            })
                        ]
                    });
                    var memberPrePasswordEnrollLink = link.set('memberPrePasswordEnroll', {
                        "label": "Enroll",
                        "url": false,
                        "mSite": false,
                        "filterData": {
                            "brand": ['*'],
                            "portal": "member"
                        },
                        "links": [
                            link.set("memberPrePasswordEnroll1", {
                                "url":"https://medicare.highmark.com/enroll",
                                "label":"New Application",
                                "filterData": {
                                    "brand": ['*']
                                }
                            })
                        ]
                    });
                    var memberPrePasswordResourcesLink = link.set('memberPrePasswordResources', {
                        "label": "Resources",
                        "url": false,
                        "mSite": false,
                        "filterData": {
                            "brand": ['*'],
                            "portal": "member"
                        },
                        "links": [
                            link.set("memberPrePasswordResources1", {
                                "url":"https://medicare.highmark.com/resources/toolbox",
                                "label":"Toolbox",
                                "filterData": {
                                    "brand": ['*']
                                }
                            }),
                            link.set("memberPrePasswordResources2", {
                                "url":"https://medicare.highmark.com/resources/after-you-enroll",
                                "label":"After You Enroll",
                                "filterData": {
                                    "brand": ['*']
                                }
                            }),
                            link.set("memberPrePasswordResources3", {
                                "url":"https://medicare.highmark.com/resources/faq-links",
                                "label":"FAQs & Links",
                                "filterData": {
                                    "brand": ['*']
                                }
                            }),
                            link.set("memberPrePasswordResources4", {
                                "url":"https://medicare.highmark.com/resources/library",
                                "label":"Library",
                                "filterData": {
                                    "brand": ['*']
                                }
                            }),
                            link.set("memberPrePasswordResources5", {
                                "url":"https://medicare.highmark.com/contact-us.html",
                                "label":"Contact Us",
                                "filterData": {
                                    "brand": ['*']
                                }
                            }),
                        ]
                    });
                    var memberPrePasswordAdditionalLink = link.set("memberPrePasswordAdditional", {
                        "label": "Additional Links",
                        "url": false,
                        "mSite": false,
                        "filterData": {
                            "brand": ['*'],
                            "portal": "member"
                        },
                        "links": [
                            link.set("memberPrePasswordAdditional1", {
                                "url":"https://www.highmark.com/hmk2/contact/index.shtml",
                                "label":"Need Help?",
                                "newWindow": true,
                                "filterData": {
                                    "brand": ['*']
                                }
                            }),
                            link.set("memberPrePasswordAdditional2", {
                                "url":"https://reservations.highmarkbcbs.com/",
                                "label":"Find Highmark a Direct Store",
                                "newWindow": true,
                                "filterData": {
                                    "brand": ['*']
                                }
                            }),
                            link.set("memberPrePasswordAdditional3", {
                                "url":"https://www.highmark.com/hmk2/about/vision/index.shtml",
                                "label":"About Highmark",
                                "newWindow": true,
                                "filterData": {
                                    "brand": ['*']
                                }
                            }),
                            link.set("memberPrePasswordAdditional4", {
                                "url":"https://www.highmark.com/hmk2/texting.shtml",
                                "label":"SMS Texting",
                                "newWindow": true,
                                "filterData": {
                                    "brand": ['*']
                                }
                            }),
                            link.set("memberPrePasswordAdditional5", {
                                "url":"https://www.highmarkhealth.org/hmk/gdpr.shtml",
                                "label":"GDPR",
                                "newWindow": true,
                                "filterData": {
                                    "brand": ['*']
                                }
                            })
                        ],
                        "linkFilters": ["brand", "msite", "postPassword"]
                    });

                    var footerLinks = navigation.get('footerLinks')[0];
                    footerLinks.links = [memberPrePasswordLearnLink, memberPrePasswordCompareShopLink,
                        memberPrePasswordEnrollLink, memberPrePasswordResourcesLink, memberPrePasswordAdditionalLink];

                    // Overide brand links and brand disclaimer
                    var medicareFooterCopyLink1 = link.set("medicareFooterCopy1", {
                        "label": "Legal and Policies",
                        "url": "https://medicare.highmark.com/legal-policies",
                        "mSite": false,
                        "newWindow": true,
                        "filterData": {
                            "brand": ['*']
                        }
                    });

                    var medicareFooterCopyLink2 = link.set("medicareFooterCopy2", {
                        "label": "Terms of Service",
                        "url": "https://www.highmark.com/hmk2/terms.shtml",
                        "mSite": false,
                        "newWindow": true,
                        "filterData": {
                            "brand": ['*']
                        }
                    });


                    var medicareFooterCopyLink4 = link.set("medicareFooterCopy4", {
                        "url":"https://www.highmark.com/hmk2/privacy.shtml",
                        "label":"Privacy Policy and Notice of Privacy Practices",
                        "mSite": false,
                        "newWindow": true,
                        "brandVisibility": ['hmbcbs', 'hbcbs', 'highmarkbcbs']
                    });

                    var medicareFooterCopyLink5 = link.set("medicareFooterCopy5", {
                        "url":"https://www.highmark.com/privacy.html",
                        "label":"Privacy Policy",
                        "mSite": false,
                        "newWindow": true,
                        "brandVisibility": ["hmbcbswv", "ms", "highmarkbcbswv", "mbh:wv"]
                    });
                    var medicareFooterCopyLink6 = link.set("medicareFooterCopy6", {
                        "url":"/pdffiles/HighmarkWVnoticeofprivacy.pdf",
                        "label":"Notice of Privacy Practices",
                        "mSite": false,
                        "newWindow": true,
                        "brandVisibility": ["hmbcbswv", "ms", "highmarkbcbswv", "mbh:wv"]
                    });

                    brand.current.footerCopyLinks = [medicareFooterCopyLink1, medicareFooterCopyLink2];

                    if(medicareFooterCopyLink4.brandVisibility.indexOf(brand.current.sharedBrandCode) !== -1) {
                        brand.current.footerCopyLinks.push(medicareFooterCopyLink4);
                    } else if (medicareFooterCopyLink5.brandVisibility.indexOf(brand.current.sharedBrandCode) !== -1) {
                        brand.current.footerCopyLinks.push(medicareFooterCopyLink5);
                    }
                    if(medicareFooterCopyLink6.brandVisibility.indexOf(brand.current.sharedBrandCode) !== -1) {
                        brand.current.footerCopyLinks.push(medicareFooterCopyLink6);
                    }

                    // TODO: MOVE TO TEAMSITE
                    brand.current.footerDisclaimer = '<p class="margin-top">Highmark Senior Health Company, Highmark Choice Company and Highmark Senior Solutions Company ' +
                        'are Medicare Advantage plans with a Medicare contract.  HM Health Insurance Company is a PDP plan ' +
                        'with a Medicare contract.  Enrollment in Highmark Senior Health Company, Highmark Choice Company, ' +
                        'Highmark Senior Solutions Company and HM Health Insurance Company depends on contract  renewal.</p> ' +
                        '<p class="module-top">This site works best with the latest version of Microsoft Edge, Firefox, Chrome or Safari.</p>' +
                        '<p class="module-top">Highmark Blue Cross Blue Shield is an independent licensee of the Blue Cross Blue Shield Association, ' +
                        'an association of independent Blue Cross and Blue Shield companies. Highmark Blue Shield is an independent ' +
                        'licensee of the Blue Cross Blue Shield Association, an association of independent Blue Cross and Blue ' +
                        'Shield companies. Highmark Blue Cross Blue Shield West Virginia is an independent licensee of the Blue ' +
                        'Cross Blue Shield Association, an association of independent Blue Cross and Blue Shield companies. ' +
                        'Highmark Blue Cross Blue Shield Delaware is an independent licensee of the Blue Cross Blue Shield ' +
                        'Association, an association of independent Blue Cross and Blue Shield companies.</p>';

                }
                angular.element($window).on('resize', function () {
                    footerResize();
                    $scope.$apply();
                });
            }],
            template: require('articles/footer.html')
        };
    }]);
};